export default __webpack_public_path__ + "static/BayswaterCarousel_0001-0684a9279c739f21609d26e61046a81a.jpg";